function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm2.675 8.571c-3.009 0-5.07 1.893-5.07 5.37v3.202h-3.32v4.063h3.32v10.223h4.07V21.207h3.186l.506-4.063h-3.692v-2.8c0-1.174.317-1.977 1.953-1.977h2.086V8.732c-.36-.05-1.598-.16-3.04-.16z"
});

function SvgCombinedShapeCopy4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0yMCAwYzExLjA0NiAwIDIwIDguOTU0IDIwIDIwcy04Ljk1NCAyMC0yMCAyMFMwIDMxLjA0NiAwIDIwIDguOTU0IDAgMjAgMHptMi42NzUgOC41NzFjLTMuMDA5IDAtNS4wNyAxLjg5My01LjA3IDUuMzd2My4yMDJoLTMuMzJ2NC4wNjNoMy4zMnYxMC4yMjNoNC4wN1YyMS4yMDdoMy4xODZsLjUwNi00LjA2M2gtMy42OTJ2LTIuOGMwLTEuMTc0LjMxNy0xLjk3NyAxLjk1My0xLjk3N2gyLjA4NlY4LjczMmMtLjM2LS4wNS0xLjU5OC0uMTYtMy4wNC0uMTZ6Ii8+Cjwvc3ZnPgo=";
export { SvgCombinedShapeCopy4 as ReactComponent };